var path = 'public/app/plugins/datasource/grafana-live/partials/query.editor.html';
var html = "<query-editor-row query-ctrl=ctrl can-collapse=false>\n\t<div class=gf-form-inline>\n\t\t<div class=\"gf-form gf-form--grow\">\n\t\t\t<label class=\"gf-form-label width-8\">Stream</label>\n\t\t\t<input type=text class=gf-form-input ng-model=ctrl.target.stream spellcheck=false placeholder=metric>\n\t\t</div>\n\t</div>\n</query-editor-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./public/app/plugins/datasource/grafana-live/partials/query.editor.html
// module id = 870
// module chunks = 2